import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/index.css";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Story from "@/pages/Story";
import Celebrations from "@/pages/Celebrations";
import EventDetail from "@/pages/EventDetail";
import Invitation from "@/pages/Invitation";
import DressCode from "@/pages/DressCode";
import FAQs from "@/pages/FAQs";
import Gallery from "@/pages/Gallery";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { InvitationBand } from "@/pages/Home";
import { GuestProvider, useGuest } from "@/lib/GuestContext";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 350);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);
  return null;
}

function Shell({ children }) {
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen flex flex-col">
      <Nav />
      <main key={pathname} className="flex-1 page-enter">{children}</main>
      <Footer />
    </div>
  );
}

function GuestOnly({ children }) {
  const { guest, loading } = useGuest();
  if (loading) return <div className="py-32 text-center font-hand text-2xl" data-testid="guest-loading">One moment…</div>;
  if (!guest?.events?.length) return <div data-testid="invite-gate"><InvitationBand /></div>;
  return children;
}

function AdminGuard({ children }) {
  const token = typeof window !== "undefined" ? localStorage.getItem("nigi_admin_token") : null;
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <GuestProvider>
      <ScrollManager />
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<Shell><Home /></Shell>} />
        <Route path="/story" element={<Shell><Story /></Shell>} />
        <Route path="/celebrations" element={<Shell><GuestOnly><Celebrations /></GuestOnly></Shell>} />
        <Route path="/celebrations/:slug" element={<Shell><GuestOnly><EventDetail /></GuestOnly></Shell>} />
        <Route path="/travel" element={<Navigate to="/" replace />} />
        <Route path="/dress-code" element={<Shell><GuestOnly><DressCode /></GuestOnly></Shell>} />
        <Route path="/faqs" element={<Shell><FAQs /></Shell>} />
        <Route path="/gallery" element={<Shell><Gallery /></Shell>} />
        <Route path="/invite/:token" element={<Invitation />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminGuard><AdminDashboard /></AdminGuard>} />
      </Routes>
      </GuestProvider>
    </BrowserRouter>
  );
}
